import React from "react";
import { withTranslation } from "react-i18next";
import { Form, Input, Typography } from "antd";
import styled from "styled-components";
import { SEC_FONT_GREY } from "../../constant/colors";

const { Text } = Typography;

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    &::before {
      display: none;
    }
    &::after {
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      content: "*";
      color: ${SEC_FONT_GREY};
    }
  }
`;

const DosageFormItemComponent = ({
  t,
  style,
  label,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  dataTMId,
  name = "drugDosage",
  recordInfo
}) => (
  <FormItemStyled
    name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
    colon={false}
    label={showLabel ? <Text strong={strong}>{label ? label : t("form.dosage.label")}</Text> : null}
    rules={[
      { required, message: t("form.dosage.error_required") },
      {
        pattern: /^(\d+(.\d+)?)(-(\d+(.\d+)?))*$/,
        message: t("form.dosage.error_validation")
      }
    ]}
    style={style}
  >
    <Input data-tm-id={dataTMId} disabled={!editable} placeholder={t("form.dosage.placeholder")} />
  </FormItemStyled>
);

const DosageFormItem = withTranslation()(DosageFormItemComponent);

export { DosageFormItem };
